<svg width="24" height="24" viewBox="0 0 24 24">
  <path
    d="M12.394 13.9859C12.3311 14.0457 12.2017 14.1046 12.1044 14.1046C12.0056 14.1029 11.9121 14.0849 11.8151 13.9859L8.23615 10.6175C8.07105 10.4627 8.05655 10.1881 8.21965 10.0221C8.37415 9.86481 8.65485 9.85409 8.81505 10.0057L11.6835 12.7096L11.7778 12.791C11.9654 12.9529 12.2434 12.953 12.4311 12.7911L12.5255 12.7096L15.3941 10.0057C15.5543 9.85409 15.842 9.8582 15.9896 10.0221C16.1545 10.2054 16.1357 10.4602 15.9732 10.6175L12.394 13.9859Z"
    fill="currentColor"
    stroke="currentColor"
    stroke-linecap="butt"
    stroke-linejoin="miter"
    stroke-width="1"
  />
</svg>
